export default {"src":"/_next/static/media/illustration-feed.b9f723d0.svg","height":152,"width":152};